import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountAdditionalServicesRoutes = [
  {
    path: 'additionalservices',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Additional Services')
      },
      permissions: ['READ_ADDITIONAL_SERVICES']
    },
    children: [
      {
        path: '',
        name: 'additionalServicesList',
        component: wrapLegacyRoute('additionalServicesController', 'list')
      },
      {
        path: 'create',
        name: 'additionalServiceCreate',
        component: wrapLegacyRoute('additionalServicesController', 'create')
      },
      {
        path: ':additionalServiceId(\\d+)',
        name: 'additionalServiceDetails',
        component: wrapLegacyRoute('additionalServicesController', 'details')
      }
    ]
  }
];

export default accountAdditionalServicesRoutes;
